'use strict';

const Util = require('../util/util');
const { ValidationError } = require('../erros');
const Localizacao = require('./localizacao');
const mongoose = require('mongoose');

const Paciente = {
    pesquisar: async (dbClient, idPaciente, idEnderecoPaciente) => {
        const consulta = dbClient('public.paciente AS p');

        consulta.where('p.id', '=', idPaciente);

        consulta.select('p.*');

        const paciente = await consulta.first();

        paciente.contatos = await Paciente.buscarContatos(dbClient, idPaciente);

        if (paciente.id_sexo) {
            paciente.sexo = await Paciente.buscarSexo(dbClient, paciente.id_sexo);
        }

        if (paciente.id_raca) {
            paciente.raca = await Paciente.buscarRaca(dbClient, paciente.id_raca);
        }

        if (paciente.id_cidade_nascimento) {
            paciente.cidade_nascimento = await Localizacao.buscarEstadoPaisPorCidade(dbClient, { idCidade: paciente.id_cidade_nascimento });
            if (paciente.cidade_nascimento && paciente.cidade_nascimento.length > 0) {
                paciente.cidade_nascimento = paciente.cidade_nascimento[0];
            }
        }

        if (idEnderecoPaciente) {
            paciente.endereco = await Paciente.buscarEnderecoPaciente(dbClient, idEnderecoPaciente);
        } else if (paciente.id_endereco_paciente) {
            paciente.endereco = await Paciente.buscarEnderecoPaciente(dbClient, paciente.id_endereco_paciente);
        }

        return paciente;
    },

    buscarRaca: async (dbClient, idRaca) => {
        return await dbClient('public.raca as r').select('r.*').where('r.id', '=', idRaca).first();
    },

    buscarSexo: async (dbClient, idSexo) => {
        return await dbClient('public.sexo as s').select('s.*').where('s.id', '=', idSexo).first();
    },

    buscarContatos: async (dbClient, idPaciente) => {
        let consulta = dbClient('public.contato_paciente AS cp').join('public.tipo_contato AS tc', 'cp.id_tipo_contato', '=', 'tc.id').where('cp.id_paciente', '=', idPaciente);

        return consulta.select('cp.contato', 'tc.id AS id_tipo_contato', 'tc.descricao AS descricao_tipo_contato', 'tc.categoria AS categoria_tipo_contato');
    },

    buscarEnderecoPaciente: async (dbClient, idEnderecoPaciente) => {
        let consulta = dbClient('public.endereco_paciente AS ep')
            .leftJoin('public.pais AS p', 'ep.id_pais', '=', 'p.id')
            .leftJoin('public.estado AS e', 'ep.id_estado', '=', 'e.id')
            .leftJoin('public.cidade AS c', 'ep.id_cidade', '=', 'c.id');

        consulta.where('ep.id', '=', idEnderecoPaciente);

        return consulta
            .select(
                'ep.cep',
                'ep.referencia as referencia_endereco',
                'ep.logradouro',
                'ep.bairro',
                'ep.numero',
                'p.nome AS pais',
                'p.id AS id_pais',
                'p.sigla AS sigla_pais',
                'e.nome AS estado',
                'e.id AS id_estado',
                'e.sigla AS sigla_estado',
                'c.nome AS cidade',
                'c.id AS id_cidade'
            )
            .first();
    },

    salvar: async (dbClient, transactionHandler, paciente, idFuncionario) => {

        let id = paciente.id;
        let cpf = paciente.cpf && paciente.cpf !== '' ? paciente.cpf : null;
        let pacienteCpf = null;
        let pacienteCns = null;

        if (cpf) {
            cpf = await Util.removerMascaraNumero(cpf);
        }
        if (!id) {
            // Verifica se existe paciente cadastrado com o CPF e/ou CNS.
            // Se existir gera erro, pois nesse caso o paciente deve ser
            // selecionado através da busca e não ter seus dados preenchidos
            // como se fosse um paciente novo.
            if (cpf) {
                pacienteCpf = await Paciente.buscarPorCpf(dbClient, cpf);
            }
            if (paciente.cns) {
                pacienteCns = await Paciente.buscarPorCns(dbClient, paciente.cns);
            }
            if (pacienteCpf && pacienteCpf.length > 0 && pacienteCns && pacienteCns.length > 0) {
                throw new ValidationError('Já existe um paciente com o CPF e o CNS informados');
            } else if (pacienteCpf && pacienteCpf.length > 0) {
                throw new ValidationError('Já existe um paciente com o CPF informado xxx');
            } else if (pacienteCns && pacienteCns.length) {
                throw new ValidationError('Já existe um paciente com o CNS informado');
            }
        }

        let dados = {
            nome: paciente.nome,
            cpf: cpf,
            cartao_sus: paciente.cns || paciente.cartao_sus,
            data_nascimento: paciente.dataNascimento || paciente.data_nascimento,
            id_funcionario_cadastro: idFuncionario,
            data_cadastro: new Date()
        }

        if (paciente.genero) {
            if (paciente.genero.id) {
                dados.id_sexo = paciente.genero.id;
            } else if (paciente.genero.sigla) {
                const sexo = await Paciente.buscarSexoPorSigla(dbClient, paciente.genero.sigla);
                if (sexo) {
                    dados.id_sexo = sexo.id;
                }
            } else {
                const sexo = await Paciente.buscarSexoIgnorado(dbClient);
                dados.id_sexo = sexo.id;
            }
        } else if (paciente.id_sexo) {
            dados.id_sexo = paciente.id_sexo;
        } else {
            const sexo = await Paciente.buscarSexoIgnorado(dbClient);
            dados.id_sexo = sexo.id;
        }

        if (paciente.nomeMae || paciente.nome_mae) {
            dados.nome_mae = paciente.nomeMae || paciente.nome_mae;
        }

        if (paciente.grupoSanguineo) {
            dados.grupo_sanguineo = paciente.grupoSanguineo;
        }

        if (paciente.fatorRh) {
            dados.fator_rh = paciente.fatorRh;
        }

        if (paciente.raca?.id) {
            dados.id_raca = paciente.raca.id;
        }

        if (paciente.justificativa) {
            dados.observacao = paciente.justificativa;
        }

        let idEndereco;
        if (id) {
            dados = {
                ...dados,
                id_funcionario_alteracao: idFuncionario
            }
            await dbClient('public.paciente').where('id', '=', id).update(dados).transacting(transactionHandler);
        } else {
            dados = {
                ...dados,
                id_funcionario_cadastro: idFuncionario,
                data_cadastro: new Date()
            }
            const result = await dbClient.insert(dados).into('public.paciente').returning('id').transacting(transactionHandler);
            id = result[0];
        }
        // Salva dados de endereço
        idEndereco = await Paciente.salvarEndereco(dbClient, transactionHandler, id, paciente);

        // Relaciona o endereço ao paciente
        await dbClient('public.paciente')
            .where('id', '=', id)
            .update({ id_endereco_paciente: idEndereco })
            .transacting(transactionHandler);

        // Salva os contatos
        await Paciente.salvarContatos(dbClient, transactionHandler, id, paciente);
        paciente.id = id;
        paciente.id_endereco_paciente = idEndereco;
        return paciente;
    },

    atualizar: async (dbClient, transactionHandler, dados) => {
        await dbClient('public.paciente').where('id', '=', dados.id).update(dados).transacting(transactionHandler);
    },

    atualizarProvisorio: async (dbClient, transactionHandler, dados) => {
        await dbClient('public.paciente_provisorio')
            .where('id', '=', dados.id)
            .update(dados)
            .transacting(transactionHandler);
    },

    atualizarMongo: async (idPaciente, dados, config) => {
        // Conectar ao banco "teleatendimento"
        const connTeleatendimento = mongoose.createConnection(config.mongodb_url_teleatendimento);
        // Conectar ao banco "conecta"
        const connConecta = mongoose.createConnection(config.mongodb_url_conecta);

        let resultados = {
            agendamentos: 0,
            atendimentosPacienteAtendido: 0,
            atendimentosRegistros: 0,
            eventosConecta: 0
        };

        // Função auxiliar para criar objeto $set preservando apenas os campos alterados
        const criarSetObject = (prefixo, dados, idPaciente) => {
            const setObject = {};
            Object.keys(dados).forEach(key => { setObject[`${prefixo}.${key}`] = dados[key]; });
            setObject[`${prefixo}.id`] = idPaciente;
            return { $set: setObject };
        };

        try {
            // Atualizar agendamentos no banco "teleatendimento"
            const setAgendamentos = criarSetObject("paciente", dados, idPaciente);
            const resultAgendamentos = await connTeleatendimento.collection('agendamentos').updateMany(
                { "paciente.id": idPaciente },
                setAgendamentos
            );
            resultados.agendamentos = resultAgendamentos.modifiedCount;

            // Atualizar atendimentos no banco "teleatendimento" - pacienteAtendido
            const setPacienteAtendido = criarSetObject("pacienteAtendido", dados, idPaciente);
            const resultAtendimentosPaciente = await connTeleatendimento.collection('atendimentos').updateMany(
                { "pacienteAtendido.id": idPaciente },
                setPacienteAtendido
            );
            resultados.atendimentosPacienteAtendido = resultAtendimentosPaciente.modifiedCount;

            // Atualizar atendimentos no banco "teleatendimento" - registros array
            const setRegistros = {};
            Object.keys(dados).forEach(key => { setRegistros[`registros.$[elem].paciente.${key}`] = dados[key]; });
            setRegistros["registros.$[elem].paciente.id"] = idPaciente;
            const resultAtendimentosRegistros = await connTeleatendimento.collection('atendimentos').updateMany(
                { "registros.paciente.id": idPaciente },
                { $set: setRegistros },
                { arrayFilters: [{ "elem.paciente.id": idPaciente }] }
            );
            resultados.atendimentosRegistros = resultAtendimentosRegistros.modifiedCount;

            // Atualizar no banco "conecta" - collection "evento" (atualizar paciente dentro do array "registros")
            const setEventos = {};
            Object.keys(dados).forEach(key => { setEventos[`registros.$[elem].paciente.${key}`] = dados[key]; });
            const resultEventos = await connConecta.collection('evento').updateMany(
                { "registros.paciente.id": idPaciente },
                { $set: setEventos },
                { arrayFilters: [{ "elem.paciente.id": idPaciente }] }
            );
            resultados.eventosConecta = resultEventos.modifiedCount;

            console.log('Registros alterados no MongoDb:', resultados);

            return resultados;
        } catch (error) {
            console.error('Erro ao atualizar dados no MongoDB:', error);
            throw error;
        } finally {
            // Fechar as conexões
            await connTeleatendimento.close();
            await connConecta.close();
        }
    },

    salvarEndereco: async (dbClient, transactionHandler, idPaciente, dados) => {
        const dadosEndereco = {
            id_paciente: idPaciente,
            logradouro: dados.logradouro,
            bairro: dados.bairro,
            referencia: dados.referencia || null
        };
        if (dados.cep) {
            dadosEndereco.cep = (dados.cep + '').replace(/\D/g, '');
        }
        if (dados.municipio) {
            dadosEndereco.id_cidade = dados.municipio.id;
        }
        if (dados.uf) {
            dadosEndereco.id_estado = dados.uf.id;
        }
        if (dados.pais) {
            dadosEndereco.id_pais = dados.pais.id;
        }
        if (dados.numero) {
            dadosEndereco.numero = dados.numero;
        }
        let result;
        if (dados.id_endereco_paciente) {
            result = await dbClient('public.endereco_paciente').where('id', '=', dados.id_endereco_paciente).update(dadosEndereco).returning('id').transacting(transactionHandler);
        } else {
            result = await dbClient.insert(dadosEndereco).into('public.endereco_paciente').returning('id').transacting(transactionHandler);
        }
        return result[0];

    },

    salvarContatos: async (dbClient, transactionHandler, idPaciente, dados) => {
        // Remove todos os contatos do paciente
        await Paciente.removerContatos(dbClient, transactionHandler, idPaciente);
        // Insere o primeiro contato, caso tenha sido informado
        if (dados.tipoContato1 && dados.contato1) {
            let contato1 = await Util.removerMascaraNumero(dados.contato1);
            await dbClient
                .insert({
                    id_paciente: idPaciente,
                    id_tipo_contato: dados.tipoContato1,
                    contato: contato1,
                    contato_whatsapp: dados.contato1Whatsapp ? true : false
                })
                .into('public.contato_paciente')
                .transacting(transactionHandler);
        }

        // Insere o segundo contato, caso tenha sido informado
        if (dados.tipoContato2 && dados.contato2) {
            let contato2 = await Util.removerMascaraNumero(dados.contato2);
            await dbClient
                .insert({
                    id_paciente: idPaciente,
                    id_tipo_contato: dados.tipoContato2,
                    contato: contato2,
                    contato_whatsapp: dados.contato2Whatsapp ? true : false
                })
                .into('public.contato_paciente')
                .transacting(transactionHandler);
        }

        if (dados.tipoContatoEmail && dados.email) {
            await dbClient
                .insert({
                    id_paciente: idPaciente,
                    id_tipo_contato: dados.tipoContatoEmail,
                    contato: dados.email,
                    contato_whatsapp: false
                })
                .into('public.contato_paciente')
                .transacting(transactionHandler);
        }
    },

    removerContatos: async (dbClient, transactionHandler, idPaciente) => {
        await dbClient('public.contato_paciente').where('id_paciente', '=', idPaciente).del().transacting(transactionHandler);
    },

    buscarPorCns: async (dbClient, cns) => {
        return await dbClient('public.paciente AS p').where('p.cartao_sus', '=', cns);
    },

    buscarPorCpf: async (dbClient, cpf) => {
        return await dbClient('public.paciente AS p').where('p.cpf', '=', cpf);
    },

    /**
     * Conta o total de pacientes (provisórios e definitivos) pelo CPF, Cartão SUS ou Nome.
     * @param {*} dbClient
     * @param {Object} filtro - { cpf, cns, nome }
     * @returns {Promise<number>}
     */
    countPacientes: async (dbClient, filtro) => {
        if (!filtro || (!filtro.cpf && !filtro.cns && !filtro.nome)) {
            throw new Error('É obrigatório informar CPF, CNS ou nome para contagem.');
        }

        const cpf = filtro.cpf ? await Util.removerMascaraNumero(filtro.cpf) : null;
        const cns = filtro.cns || null;
        const nome = filtro.nome ? `%${filtro.nome}%` : null;

        let whereProvisorio = [];
        let wherePaciente = [];
        let params = [];

        if (cns) {
            whereProvisorio.push(`pp.cartao_sus = ?`);
            wherePaciente.push(`p.cartao_sus = ?`);
            params.push(cns);
        }
        if (cpf) {
            whereProvisorio.push(`pp.cpf = ?`);
            wherePaciente.push(`p.cpf = ?`);
            params.push(cpf);
        }
        if (nome) {
            whereProvisorio.push(`pp.nome ilike ?`);
            wherePaciente.push(`p.nome ilike ?`);
            params.push(nome);
        }

        const whereProvisorioStr = whereProvisorio.length > 0 ? whereProvisorio.join(' or ') : '1=0';
        const wherePacienteStr = wherePaciente.length > 0 ? wherePaciente.join(' or ') : '1=0';

        const rawQuery = `
            select count(*) as total from (
                select 'pp_' || pp.id as id
                from public.paciente_provisorio pp
                where ${whereProvisorioStr}
                union all
                select 'p_' || p.id as id
                from public.paciente p
                where ${wherePacienteStr}
            ) t
        `;

        const result = await dbClient.raw(rawQuery, [...params, ...params]);
        const total = result.rows ? result.rows[0].total : result[0].total;
        return Number(total);
    },

    buscarSexoIgnorado: async (dbClient) => {
        return await Paciente.buscarSexoPorSigla(dbClient, 'I');
    },

    buscarSexoPorSigla: async (dbClient, sigla) => {
        return await dbClient('public.sexo as s').select('s.*').where('s.sigla', '=', sigla).first();
    }
};

module.exports = Paciente;
